import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material";
import { HttpErrorResponse } from "@angular/common/http";
import { BaseDialog } from "../../../base-dialog";
import {
  TemporaryReleaseResult,
  TemporaryReleaseService,
  TEMPORARY_RELEASE_ACCEPTED_TYPES,
  TEMPORARY_RELEASE_MAX_FILE_BYTES,
} from "../temporary-release.service";

/**
 * Modal "Já paguei", de envio do comprovante. Fecha com o resultado do billing-services em caso de
 * sucesso, ou com null se o seller cancelar. Na v1 não promete prazo: a liberação vale no mínimo
 * 24h, mas o rebloqueio só acontece na rodada do job, então um horário exato seria impreciso.
 */
@Component({
  selector: "mandae-payment-proof-dialog",
  templateUrl: "./payment-proof-dialog.component.html",
  styleUrls: ["./payment-proof-dialog.component.scss"],
})
export class PaymentProofDialogComponent extends BaseDialog<PaymentProofDialogComponent> {
  public readonly acceptedTypes = TEMPORARY_RELEASE_ACCEPTED_TYPES.join(",");
  public file: File = null;
  public error: string = null;
  public sending = false;

  constructor(
    dialogRef: MatDialogRef<PaymentProofDialogComponent>,
    private temporaryRelease: TemporaryReleaseService
  ) {
    super(dialogRef);
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    this.file = input.files && input.files.length ? input.files[0] : null;
    this.error = this.file ? this.validate(this.file) : null;
  }

  send() {
    if (!this.file) {
      this.error = "Selecione o comprovante de pagamento.";
      return;
    }
    const invalid = this.validate(this.file);
    if (invalid) {
      this.error = invalid;
      return;
    }

    this.sending = true;
    this.error = null;
    this.temporaryRelease.requestRelease(this.file).subscribe(
      (result: TemporaryReleaseResult) => {
        this.sending = false;
        this.dialogRef.close(result);
      },
      (error: HttpErrorResponse) => {
        this.sending = false;
        this.error = this.temporaryRelease.errorMessage(error);
      }
    );
  }

  private validate(file: File): string | null {
    if (TEMPORARY_RELEASE_ACCEPTED_TYPES.indexOf((file.type || "").toLowerCase()) < 0) {
      return "Envie o comprovante em PDF, JPG ou PNG.";
    }
    if (file.size === 0) {
      return "O arquivo selecionado está vazio.";
    }
    if (file.size > TEMPORARY_RELEASE_MAX_FILE_BYTES) {
      return "O comprovante deve ter no máximo 5 MB.";
    }
    return null;
  }
}
